import { Container, Row, Col } from 'react-bootstrap';
import React from 'react';
import { Link } from 'react-router-dom';

const FooterHeader = ({ children }: { children: React.ReactNode }) => (
  <h6>
    <strong>{children}</strong>
  </h6>
);

const FooterItem = ({ children }: { children: React.ReactNode }) => (
  <div className="mb-1">{children}</div>
);

const SiteFooter = () => (
  <footer className="bg-dark-subtle py-5 border-top">
    <Container>
      <Row className="justify-content-center text-start gap-5">
        <Col lg={3} className="p-2">
          <FooterHeader>Hours</FooterHeader>
          <FooterItem>Monday – Friday</FooterItem>
        </Col>
        <Col lg={3} className="p-2">
          <FooterHeader>Contact Us</FooterHeader>
          <FooterItem>
            Email:{' '}
            <a href="mailto:info@aspenfunctionalhealth.com">
              info@aspenfunctionalhealth.com
            </a>
          </FooterItem>
          <FooterItem>
            Phone: <a href="tel:4255411271">425-541-1271</a>
          </FooterItem>
          <FooterItem>
            Fax: <a href="tel:8885226376">888-522-6376</a>
          </FooterItem>
        </Col>
        <Col lg={3} className="p-2">
          <FooterHeader>Links</FooterHeader>
          <FooterItem>
            <Link to="/faqs">FAQs</Link>
          </FooterItem>
          <FooterItem>
            <Link to="/careers">Careers</Link>
          </FooterItem>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default SiteFooter;
